/**
 * Public Entry Point - New Frontend System
 *
 * This file provides the public (unauthenticated) entry point for Allen.
 * It renders only the sign-in page before authentication completes.
 *
 * The filename `index-public-experimental.tsx` follows Backstage convention
 * and is automatically used by the Backstage CLI for the public entry.
 *
 * @see https://backstage.io/docs/tutorials/enable-public-entry#new-frontend-system
 */

import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import ReactDOM from 'react-dom/client';
import { createApp } from '@backstage/frontend-defaults';
import { appModulePublicSignIn } from '@backstage/plugin-app/alpha';
import { appModuleSignInPage } from './overrides/SignInPage';
import { appModuleThemeIconsAndComponents } from './overrides/appUIOverrides';

/**
 * Create the public app with sign-in page and public sign-in module
 */
const app = createApp({
  features: [
    appModuleThemeIconsAndComponents,
    appModuleSignInPage,
    appModulePublicSignIn,
  ],
});

ReactDOM.createRoot(document.getElementById('root')!).render(app.createRoot());
